import { render } from "./researcherpost.vue?vue&type=template&id=1fd98ff1"
import script from "./researcherpost.vue?vue&type=script&lang=js"
export * from "./researcherpost.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__